import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ValidationService } from 'shared/services';
import { Input } from 'shared/components';
import { withTranslation } from 'react-i18next';

const INPUT_MAX_LENGTH = 22;
const CITY_LABEL = 'city';
const STATE_CODE_LABEL = 'stateCode';
const POSTAL_CODE_LABEL = 'postalCode';

class ZipForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: {},
    };

    this.onZipChange = this.onZipChange.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.isValueChanged = this.isValueChanged.bind(this);
  }

  onZipChange(e) {
    const zipAddressData = { postalCode: e.target.value };
    let error = '';

    if (!ValidationService.numeric(e.target.value) || e.target.value.length > 5) {
      return;
    }
    if (e.target.value && !ValidationService.len(e.target.value, 5)) {
      error = 'errors.zipLength';
      this.setState({
        error: {
          postalCode: error,
        },
      });
    } else {
      this.setState({ error: {} });
    }

    /* if (e.target.value.length === 5 && false) {
      const zipData = zipcodes.lookup(e.target.value);
      if (zipData) {
        zipAddressData.stateCode = zipData.state;
        zipAddressData.city = zipData.city;
      }
    } */
    this.props.handleChange(
      { ...this.props.address, ...zipAddressData },
      e.target.name,
      e.target.value,
      error
    );
  }

  handleChange(e) {
    const { target } = e;
    const STATE_CODE_LENGTH = 2;
    let errorValue = '';

    if (!ValidationService.letters(target.value)) {
      return;
    }

    if (target.name === 'stateCode') {
      target.value = target.value.toUpperCase();
      if (target.value.length > STATE_CODE_LENGTH) {
        return;
      }
      if (target.value && target.value.length < STATE_CODE_LENGTH) {
        errorValue = 'errors.stateCodeLength';
      } else if (
        target.value.length === STATE_CODE_LENGTH &&
        !ValidationService.validState(target.value)
      ) {
        errorValue = 'errors.invalidState';
      }
      this.setState({
        error: {
          [target.name]: errorValue,
        },
      });
    }

    if (target.name === 'city') {
      if (target.value.length > INPUT_MAX_LENGTH) {
        this.setState({
          error: {
            [target.name]: this.props.t('errors.fieldLimitation', { limit: INPUT_MAX_LENGTH }),
          },
        });
        errorValue = this.props.t('errors.fieldLimitation', { limit: INPUT_MAX_LENGTH });
      }
    }

    if (!errorValue) {
      this.setState({ error: {} });
    }

    this.props.handleChange(
      {
        ...this.props.address,
        [target.name]: target.value,
      },
      target.name,
      target.value,
      errorValue
    );
  }

  isValueChanged(name) {
    const { address, addressSavedValue } = this.props;

    return !!addressSavedValue && address[name] !== addressSavedValue[name];
  }

  render() {
    const { address, errors, readOnly, clearValue } = this.props;
    const { error } = this.state;

    return (
      <div className="ZipForm">
        <div className="list-group-item">
          <Input
            size="w-100"
            type="text"
            name={CITY_LABEL}
            id="ZipFormCity"
            value={address.city}
            onChange={this.handleChange}
            label="common.labels.city"
            readOnly={readOnly}
            errors={errors.city || error.city}
            clearValue={clearValue ? () => clearValue(CITY_LABEL) : null}
            isValueChanged={this.isValueChanged(CITY_LABEL)}
            required
          />
        </div>
        <div className="list-group-item">
          <Input
            className="text-uppercase"
            size="w-100"
            type="text"
            name={STATE_CODE_LABEL}
            id="ZipFormStateCode"
            value={address.stateCode}
            onChange={this.handleChange}
            label="common.labels.stateProvince"
            readOnly={readOnly}
            errors={errors.stateCode || error.stateCode}
            clearValue={clearValue ? () => clearValue(STATE_CODE_LABEL) : null}
            isValueChanged={this.isValueChanged(STATE_CODE_LABEL)}
            required
          />
        </div>
        <div className="list-group-item">
          <Input
            size="w-50"
            type="text"
            name={POSTAL_CODE_LABEL}
            id="ZipFormPostalCode"
            value={address.postalCode}
            onChange={this.onZipChange}
            label="common.labels.zip"
            readOnly={readOnly}
            errors={errors.postalCode || error.postalCode}
            isValueChanged={this.isValueChanged(POSTAL_CODE_LABEL)}
            clearValue={clearValue ? () => clearValue(POSTAL_CODE_LABEL) : null}
            required
          />
        </div>
      </div>
    );
  }
}

export default withTranslation()(ZipForm);
ZipForm.propTypes = {
  address: PropTypes.shape({}).isRequired,
  errors: PropTypes.shape({}).isRequired,
  handleChange: PropTypes.func.isRequired,
  addressSavedValue: PropTypes.shape({}),
  t: PropTypes.func.isRequired,
};

ZipForm.defaultProps = {
  addressSavedValue: null,
};
